<template>
  <div class="angio-pdf">
    <div v-if="viewNum == -1" class="mark flex justify_content_center align_items_center">您访问的文档超出访问次数限制，暂时无法访问，如需浏览请联系杭州脉流科技有限公司。</div>
    <div v-if="viewNum == -2" class="mark flex justify_content_center align_items_center">您访问的文档暂时无法访问</div>
    <iframe v-else ref="iframe" id="iframe" :src="pdfUrl" frameborder="0" scrolling="no" class="pdf-iframe"></iframe>
    <!-- <embed ref="iframe" :src="pdfUrl" class="pdf-iframe" type="application/pdf" height={600} width="100%" /> -->
  </div>
</template>

<script>
// import pdf from 'vue-pdf'
// // 解决部分文字不显示的问题
// import CMapReaderFactory from 'vue-pdf/src/CMapReaderFactory.js'
// import { base64toBlobUrl } from '@/utils/common'
export default {
  components: {
    // pdf
  },
  data () {
    return {
      viewNum: null,
      id: '',
      // pdfUrl: 'https://www.arteryflow.com/file/official-website/angio.pdf#toolbar=0',
      // src: 'https://www.arteryflow.com/file/test/ica.pdf',
      pdfUrl: '', // pdf文件地址
      pageCount: 0, // 当前页
      numPages: 0 // 总页数
    }
  },
  mounted () {
    this.id = this.$route.query.id ? this.$route.query.id : ''
    this.getAngioPdf()
    document.oncontextmenu = function () {
      return false
    }
    // this.$nextTick(() => {
    //   console.log(this.$refs.iframe.contentWindow)
    //   console.log(this.$refs.iframe.contentDocument)
    //   // this.$refs.iframe.contentWindow.document.oncontextmenu = function () {
    //   //   console.log('111')
    //   //   return false
    //   // }
    //   console.log(this.$refs.iframe.getElementsByTagName('body'))
    //   console.log(this.$refs.iframe.contentWindow.document.getElementsByTagName('body')[0])
    //   this.$refs.iframe.contentWindow.document.getElementsByTagName('body')[0].oncontextmenu = function () {
    //     console.log('22')
    //     return false
    //   }
    //   console.log(this.$refs.iframe.contentWindow.document.oncontextmenu)
    //   // console.log(this.$refs.iframe.getElementsByTagName('embed'))
    //   // this.$refs.iframe.getElementsByTagName('embed')[0].contentWindow.document.oncontextmenu = function () {
    //   //   console.log('111')
    //   //   return false
    //   // }
    //   // console.log(this.$refs.iframe.getElementsByTagName('embed')[0].contentWindow.document.oncontextmenu)
    // })
  },
  methods: {
    getAngioPdf () {
      const parms = {
        // id: 'a822549bfc7b48f9922e5e004279db2a'
        id: this.id
      }
      this.$store.dispatch('app/getAngioPdf', parms).then((res) => {
        console.log(res)
        this.viewNum = Number(res.count)
        // console.log(base64toBlobUrl(res))
        // const base64 = `data:application/pdf;base64,${res.base64}`
        // this.pdfUrl = base64toBlobUrl(res.base64, 'application/pdf')
        if (this.viewNum >= 0) {
          this.pdfUrl = res.file + '?v=' + new Date().getTime()
        }
        // console.log(this.pdfUrl)
      }).catch((err) => {
        console.log(err)
        this.viewNum = -2
      })
    }
  }
}
</script>

<style lang="less" scoped>
.angio-pdf {
  height: 100vh;
  width: 100%;
  position: relative;
}
.mark {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  color: #ff0000;
  font-size: 30PX;
  text-align: center;
}
.pdf-iframe {
  height: calc(100vh - 10PX);
  width: 100%;
}
</style>
